import { render, staticRenderFns } from "./GameDataInfo.vue?vue&type=template&id=15d87f74&"
import script from "./GameDataInfo.vue?vue&type=script&lang=js&"
export * from "./GameDataInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports